import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

/**
 * Label:
 *  - Label for Menu in Notebook/MenuList
 */
export function Label(props) {
  const className = `${style.label} ${props.className}`;

  return (
    <div className={className} aria-hidden="true">
      <RichText value={props.title} />
      {props.maxProgress > 0 && props.displayProgress && (
        <span>
          {props.currentProgress}/{props.maxProgress}
        </span>
      )}
    </div>
  );
}

Label.propTypes = {
  /**
   * Menu Title
   */
  title: PropTypes.string,
};

Label.defaultProps = {
  title: "",
};
